export default __webpack_public_path__ + "static/media/526.f6ea0db1.svg";